module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAAHlBMVEUAAAAuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzZ+rgKZ93IJAAAACHRSTlMA8a0YJ7e1Ja++TBcAAABHSURBVBjTY0ADHB1QgI3XAFFDFG/mzJmoPAL6GtWRVXY0OiDxmCMUkPVZCCDxgCxSeIzNyDymNgMkHotEBwyA9DhJIHhUAQBMLDFLZrqN3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsjy_green.png
// module id = 9Dh6
// module chunks = 101